import React from "react";
import { Button } from "../../../../../../../../shared/Button/Button";
import styles from "./styles.module.scss";
import { CircularProgress } from "../../../../../../../../shared/CircularProgress/CircularProgress";

/**
 * @param {{
 *  onSubmit: () => void;
 *  onCancel: () => void;
 *  onForceDelete: () => void;
 *  isSubmitting: boolean;
 * }} param0
 */
export var Footer = ({ onSubmit, onCancel, onForceDelete, isSubmitting }) => (
  <div className={styles.root}>
    <Button variant="outlined" onClick={onCancel}>
      Cancel
    </Button>
    <div className={styles.right}>
      <Button color="error" onClick={onForceDelete}>
        Delete Without Transfer
      </Button>
      <Button
        onClick={onSubmit}
        isDisabled={isSubmitting}
        leftAdornment={
          isSubmitting ? (
            <CircularProgress size="small" color="white" />
          ) : undefined
        }
      >
        {"Transfer & Delete"}
      </Button>
    </div>
  </div>
);
